import React, { useContext } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Assets
import backgroundImage from "assets/images/bg-all-events.png";

//User Data
import { UserContext } from "context";

// Data
import projectsTableData from "layouts/myEvents/data/projectsTableData";

function MyEvents() {
  const { columns: pColumns, rows: pRows } = projectsTableData();
  const { user } = useContext(UserContext);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        borderRadius="xl"
        sx={{
          minHeight: { xs: "8.75rem", sm: "18.75rem" },
          backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
            `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
        }}
      >
        <MDTypography
          variant="h1"
          color="white"
          sx={{
            my: 2,
            px: { xs: 6 },
            textAlign: "center",
          }}
        >
          I Tuoi Eventi
        </MDTypography>
      </MDBox>
      <MDBox
        sx={{
          mt: { xs: 4, sm: -12 },
          mx: { xs: 0, sm: 3 },
          pt: 2,
          px: { xs: 0, sm: 2 },
        }}
      >
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-2}
                py={2}
                px={2}
                variant="gradient"
                sx={{
                  backgroundColor: "#000000",
                }}
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                alignItems="center"
              >
                <MDTypography variant="h4" color="white" sx={{ mr: 1 }}>
                  {user.isAdmin ? "Tutti gli" : ""} Eventi
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns: pColumns, rows: pRows }}
                  isSorted={true}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                  canSearch={true}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MyEvents;
